import React from 'react'

import './Heading.css'

type HeadingProps = {
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  children: React.ReactNode
}

export function Heading({ as: Tag = 'h2', children }: HeadingProps) {
  return <Tag className={`type-heading ${Tag}`}>{children}</Tag>
}
